import React from 'react';
import { siteData } from '../mock';
import { Calendar, Clock } from 'lucide-react';

const Blog = () => {
  return (
    <section id="blog" className="py-20 lg:py-32 bg-black relative overflow-hidden">
      <div className="grain-overlay opacity-30"></div>
      
      {/* Pink accent blob */}
      <div className="absolute top-1/4 right-0 w-96 h-96 bg-pink-accent opacity-10 blur-[120px] pointer-events-none"></div>

      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="section-heading mb-6">
            THOUGHTS & INSIGHTS
          </h2>
          <p className="body-large max-w-2xl mx-auto opacity-80">
            Ideas on web3, AI, art, and the future of creative technology
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {siteData.blog.map((post, index) => (
            <article
              key={post.id}
              className="blog-card group cursor-pointer animate-fade-in-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="relative overflow-hidden rounded-lg mb-6 aspect-video">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110 grayscale group-hover:grayscale-0"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-60"></div>
                <div className="grain-overlay"></div>
                
                <span className="absolute top-4 left-4 service-button bg-pink-accent text-black border-pink-accent">
                  {post.category}
                </span>
              </div>

              <div className="space-y-4">
                <div className="flex items-center gap-4 text-xs font-mono opacity-60">
                  <span className="flex items-center gap-1">
                    <Calendar size={14} />
                    {new Date(post.date).toLocaleDateString('en-US', { 
                      month: 'short', 
                      day: 'numeric', 
                      year: 'numeric' 
                    })}
                  </span>
                  <span className="flex items-center gap-1">
                    <Clock size={14} />
                    {post.readTime}
                  </span>
                </div>

                <h3 className="text-xl lg:text-2xl font-bold leading-tight group-hover:text-pink-accent transition-colors">
                  {post.title}
                </h3>

                <p className="text-sm lg:text-base opacity-70 leading-relaxed">
                  {post.excerpt}
                </p>

                <button className="text-sm font-mono uppercase tracking-wider text-pink-accent hover:underline flex items-center gap-2 group">
                  Read More
                  <span className="transition-transform group-hover:translate-x-1">→</span>
                </button>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-12">
          <button className="cta-button large bg-white bg-opacity-10 text-white border-white border-opacity-30 hover:bg-pink-accent hover:text-black hover:border-pink-accent">
            View All Posts
          </button>
        </div>
      </div>
    </section>
  );
};

export default Blog;
